// extracted by mini-css-extract-plugin
export default {"filters_tabs":"OurGallery_filters_tabs__O+-XA","gallery_show":"OurGallery_gallery_show__t2EP+"};